import React, { createContext, useContext, useState, ReactNode } from 'react';

type ViewMode = 'simple' | 'complete';

interface FinanceViewModeContextType {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  toggleViewMode: () => void;
}

const FinanceViewModeContext = createContext<FinanceViewModeContextType | undefined>(undefined);

export function FinanceViewModeProvider({ children }: { children: ReactNode }) {
  // Carrega preferência do localStorage
  const [viewMode, setViewModeState] = useState<ViewMode>(() => {
    const saved = localStorage.getItem('finance_view_mode');
    return (saved as ViewMode) || 'simple';
  });

  const setViewMode = (mode: ViewMode) => {
    setViewModeState(mode);
    localStorage.setItem('finance_view_mode', mode);
  };

  const toggleViewMode = () => {
    const newMode = viewMode === 'simple' ? 'complete' : 'simple';
    setViewMode(newMode);
  };

  return (
    <FinanceViewModeContext.Provider value={{ viewMode, setViewMode, toggleViewMode }}>
      {children}
    </FinanceViewModeContext.Provider>
  );
}

export function useFinanceViewMode() {
  const context = useContext(FinanceViewModeContext);
  if (context === undefined) {
    throw new Error('useFinanceViewMode must be used within a FinanceViewModeProvider');
  }
  return context;
}
